<template>
  <div class="flex justify-between items-center">
    <div class="flex justify-start items-center grow flex-wrap gap-[8px]">
      <nested-dropdown
        ref="filterDropdown"
        left
        size="sm"
        toggle-class="text-decoration-none toggle-custom button-primary rounded-lg py-[7px] px-1"
      >
        <template #toggle>
          <i class="k-filter-search text-[24px]" />
        </template>
        <template #header>
          <div class="p-[16px] pt-[9px] border-b-[1px] border-[#E2E2E2] text-[#000000] font-semibold">
            Filter
          </div>
        </template>
        <nested-dropdown-submenu
          label="Kategori"
          menu-class="!min-w-[200px]"
          toggle-class="!rounded-none text-left !text-[#000000] !font-medium !px-[16px] !py-[12px]"
        >
          <b-dropdown-form style="width: 200px">
            <div
              v-if="isCategoryLoading"
              class="text-center py-2 text-[12px] text-gray-500"
            >
              Memuat data...
            </div>
            <div
              v-else-if="isCategoryError"
              class="flex flex-col items-center justify-center gap-[8px] py-2"
            >
              <span class="text-[12px] text-red-500 text-center">Gagal memuat data</span>
              <b-button
                size="sm"
                variant="outline-primary"
                class="w-full !text-[12px]"
                @click.prevent="fetchCategoryOptions"
              >
                Coba Lagi
              </b-button>
            </div>
            <b-form-checkbox-group
              v-else
              v-model="selectedCategory"
              stacked
              class="text-6 [&_.custom-checkbox:not(:last-child)]:mb-[20px]"
              :options="categoryOptions"
              @input="debouncedCategoryChange"
            />
          </b-dropdown-form>
        </nested-dropdown-submenu>
        <b-button
          variant="ghost"
          size="sm"
          class="!text-[#E31A1A] !font-normal text-[12px] !px-[16px] !py-[7px] -mb-[7px] !rounded-none !rounded-b-[4px] !w-full !border-none text-left hover:bg-[#FCD4BE]"
          @click="resetFilter"
        >
          Reset Filter
        </b-button>
      </nested-dropdown>
      <div class="flex items-center rounded-[8px] h-[43.5px] overflow-hidden !border border-[#e2e2e2] has-[:focus]:border-[#f95031] w-full max-w-[320px]">
        <i
          class="k-search-normal-1 ml-[12px] text-[24px] cursor-pointer"
          @click="$refs.searchMember.focus()"
        />
        <b-form-input
          ref="searchMember"
          v-model="keyword"
          type="search"
          placeholder="Cari nama, email atau no HP"
          class="border-0 shadow-none !text-[14px]"
          size="lg"
          :debounce="DEBOUNCED_CHANGE_TIMEOUT"
          @update="triggerFilterChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { NestedDropdown, NestedDropdownSubmenu } from '@core/components/nested-dropdown'

export default {
  name: 'FilterComponent',
  components: {
    NestedDropdown,
    NestedDropdownSubmenu,
  },
  data() {
    return {
      keyword: '',
      selectedCategory: [],
      categoryOptions: [],
      isCategoryLoading: false,
      isCategoryError: false,
    }
  },
  computed: {
  },
  created() {
    this.DEBOUNCED_CHANGE_TIMEOUT = 500
    this.debouncedCategoryChange = _.debounce(this.triggerFilterChange, this.DEBOUNCED_CHANGE_TIMEOUT)
  },
  beforeDestroy() {
    if (this.debouncedCategoryChange) {
      this.debouncedCategoryChange.cancel()
    }
  },
  mounted() {
    this.keyword = this.$route.query.keyword || ''
    this.selectedCategory = this.$route.query.category ? this.$route.query.category.split(',') : []
    this.fetchCategoryOptions()
  },
  methods: {
    async fetchCategoryOptions() {
      this.isCategoryLoading = true
      this.isCategoryError = false
      try {
        const response = await this.$http_new.get('/komclass/api/v1/komlabs/campaigns/options', {
          params: { option_type: 'product_category' },
        })
        this.categoryOptions = response.data.data.map(({ option_label }) => ({
          value: option_label,
          text: option_label,
        }))
      } catch (error) {
        this.isCategoryError = true
        this.$toast({ message: 'Gagal memuat data kategori' })
      } finally {
        this.isCategoryLoading = false
      }
    },
    /**
     * Reset filter kategori dan tutup dropdown
     */
    resetFilter() {
      this.selectedCategory = []
      if (this.debouncedCategoryChange) {
        this.debouncedCategoryChange.cancel()
      }

      this.triggerFilterChange()

      const { filterDropdown } = this.$refs
      if (filterDropdown) filterDropdown.close()
    },
    /** Reset keyword dan filter kategori */
    resetAll() {
      this.keyword = ''
      this.resetFilter()
    },
    /**
     * Sinkronkan URL dan emit perubahan filter ke parent
     */
    triggerFilterChange() {
      this.updateRouteParams()
      this.emitFilterChange()
    },
    /**
     * Emit payload filter ke parent
     * @returns {{ keyword: string, category: string[] }}
     */
    emitFilterChange() {
      const payload = {
        keyword: this.keyword,
        category: [...this.selectedCategory],
      }
      this.$emit('filter-change', payload)
      return payload
    },
    getRouteQuery() {
      const query = {}
      const { tab } = this.$route.query
      if (tab) query.tab = tab
      if (this.keyword) query.keyword = this.keyword
      if (this.selectedCategory.length) query.category = this.selectedCategory.join(',')
      return query
    },
    /** Perbarui query string browser agar sesuai state filter */
    updateRouteParams() {
      const query = this.getRouteQuery()
      if (_.isEqual(query, this.$route.query)) return
      this.$router.replace({ query }).catch(() => {})
    },
  },
}
</script>
